import axios from 'axios';
import KeycloakService from './KeycloakService';
import { API_BASE_URL, API_TIMEOUT, ENABLE_API_LOGGING } from '../config/api';

class BaseApiService {
  /**
   * Create axios instance with authentication headers
   * @returns {Object} Axios instance
   */
  getAxiosInstance = () => {
    const axiosInstance = axios.create({
      baseURL: API_BASE_URL,
      timeout: API_TIMEOUT,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Add authentication token to requests if user is authenticated
    axiosInstance.interceptors.request.use((config) => {
      const token = KeycloakService.getToken();
      if (token) {
        if (ENABLE_API_LOGGING) {
          console.log('Adding auth token to request:', config.url);
        }
        config.headers.Authorization = `Bearer ${token}`;
      } else if (ENABLE_API_LOGGING) {
        console.warn('No token available for request:', config.url);
      }
      return config;
    });
    

    // Handle 401 Unauthorized errors
    axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (ENABLE_API_LOGGING) {
          console.error('API error response:', error.response?.status, error.config?.url);
        }
        if (error.response && error.response.status === 401) {
          if (ENABLE_API_LOGGING) {
            console.log('Received 401, attempting to refresh token');
          }
          // Kiểm tra xem có token không trước khi cố gắng refresh
          const token = KeycloakService.getToken();
          if (!token) {
            if (ENABLE_API_LOGGING) {
              console.log('No token available, user not authenticated');
            }
            // Không có token, user chưa đăng nhập, không cần logout
            return Promise.reject(error);
          }
          
          // Token expired or invalid, try to refresh
          return KeycloakService.getKeycloak().updateToken(5)
            .then(() => {
              // Retry the request with the new token
              if (ENABLE_API_LOGGING) {
                console.log('Token refreshed, retrying request');
              }
              const originalRequest = error.config;
              originalRequest.headers.Authorization = `Bearer ${KeycloakService.getToken()}`;
              return axios(originalRequest);
            })
            .catch((refreshError) => {
              if (ENABLE_API_LOGGING) {
                console.error('Failed to refresh token:', refreshError);
              }
              // Unable to refresh token, logout
              KeycloakService.logout();
              return Promise.reject(error);
            });
        }
        return Promise.reject(error);
      }
    );

    return axiosInstance;
  };
}

export default BaseApiService;